import Application from '@ember/application';
import Resolver from 'ember-resolver';
import loadInitializers from 'ember-load-initializers';
import config from 'my-phorest/config/environment';
import { startSentry } from 'my-phorest/sentry';
import { loadPolyfillsIfNeeded } from 'my-phorest/utils/polyfills';

import '@fontsource/inter/variable.css';
import 'text-security/text-security-disc.css';

startSentry();
export default class App extends Application {
  modulePrefix = config.modulePrefix;
  podModulePrefix = config.podModulePrefix;
  Resolver = Resolver;
}

loadInitializers(App, config.modulePrefix);
loadPolyfillsIfNeeded();

/**
 * @typedef {import('ember-source/types')} EmberTypes
 */
